import forEach from "lodash/forEach";

// reformat error keys from server side to match key.array_index.key2 (all dot delimited) keys
export default function(errorObject) {
    forEach(errorObject, function(errorMessages, key) {
        let newKey = key
            .split(".")
            // lowercase the first letter of every string key token
            .map(function(token) {
                return token.charAt(0).toLowerCase() + token.substr(1);
            })
            .join(".")
            // replace all array/dictionary key delimiters with a dot
            .replace(/[\[\]\."]+/g, ".");
        if (newKey != key) {
            errorObject[newKey] = errorMessages.slice();
            // unset old error key
            delete errorObject[key];
        }
    });
    return errorObject;
}